<template>
  <div class="scanredirect-page">
    <div class="content">
      <van-cell-group class="item-row">
        <van-cell @click="handleNavigation('help')">

          <div slot="title">
            <div style="display: flex;align-items: center">
              <van-icon name="/static/images/icon/help.svg" />
              <div class="text-content">
                <div class="text-title">{{ $t('append_field.help') }}</div>
                <div class="text-subtitle">{{ $t('append_field.network_import') }} {{ $t('append_field.mobile_mode') }} {{ $t('append_field.standalone_mode') }}</div>
              </div>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>
        <van-cell @click="handleNavigation('apk')">

          <div slot="title">
            <div style="display: flex;align-items: center">
              <van-icon name="/static/images/icon/APK.svg" />
              <div class="text-content">
                <div class="text-title">{{ $t('append_field.apk_download') }}</div>
                <div class="text-subtitle">{{ $t('append_field.android') }}  {{ $t('append_field.ios') }}</div>
              </div>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>
        <van-cell @click="handleNavigation('h5')">

          <div slot="title">
            <div style="display: flex;align-items: center">
              <van-icon name="/static/images/icon/h5.svg" />
              <div class="text-content">
                <div class="text-title">{{ $t('append_field.app_name') }}</div>
                <div class="text-subtitle">{{ $t('append_field.info_publish') }} {{ $t('append_field.send_command') }} {{ $t('append_field.upload_material') }} {{ $t('append_field.scan_connect') }}</div>
              </div>
            </div>
            <span class="cell-right"> <van-icon name="arrow"/> </span>
          </div>
        </van-cell>
      </van-cell-group>

    </div>

  </div>
</template>

<script>


import Cookies from "js-cookie";

export default {
  data() {
    return {
      language: '',
      channel: '',
      clientInfo: '',
      deviceName: ''
    }
  },
  mounted() {
    let lang = (navigator.language || navigator.browserLanguage).toLowerCase()
    // 将 zh-cn, zh-tw 等转换为 zh
    if (lang.startsWith('zh-')) {
      lang = 'zh'
    }
    this.language = lang
    
    // 从 URL 的 query 参数中提取 p 参数
    // 注意：Vue Router 和 URLSearchParams 都会自动解码 URL 参数，但会将 + 号转换为空格
    // 所以需要从原始 URL 字符串中提取，然后手动解码，以保持 + 号的正确性
    try {

      let rawP = null
      // 如果是 hash 模式（如 #/sr?p=...），需要从 hash 中提取
      const hash = window.location.hash
      const hashQuery = hash.split('?')[1]
      const pMatch = hashQuery.match(/[&]?p=([^&]+)/)
      if (pMatch) {
        rawP = pMatch[1]
      }

      
      if (rawP) {
        // 使用 decodeURIComponent 解码，这样可以正确保留 + 号
        // decodeURIComponent 不会将 + 转换为空格，只有 URLSearchParams 和某些自动解码会
        let decodedP = decodeURIComponent(rawP)
        // 解析 JSON
        const dataObj = JSON.parse(decodedP)

        this.clientInfo = dataObj.data
        if (typeof this.clientInfo === 'string' && this.clientInfo.includes(' ')) {
          const base64Pattern = /^[A-Za-z0-9+/= ]+$/
          if (base64Pattern.test(this.clientInfo)) {
            this.clientInfo = this.clientInfo.replace(/ /g, '+')
          }
        }
        this.channel = dataObj.channel
        this.deviceName = dataObj.name

      } else {
        console.warn('未找到 p 参数')
      }
    } catch (error) {
      console.error('解析 p 参数失败:', error)
      console.error('当前 URL:', window.location.href)
    }

  },
  methods: {
    /**
     * 统一处理页面跳转
     * @param {String} type - 跳转类型: 'help' 使用帮助, 'apk' APK下载, 'h5' H5助手下载
     */
    handleNavigation(type) {
      const routeMap = {
        help: {
          url: '/Help',
          query: { lang: this.language }
        },
        apk: {
          url: 'https://appstore.esoncloud.com/#/appDownload',
          query: { lang: this.language, id: '63' }
        },
        h5: {
          url: '/login',
        }
      }
      
      const route = routeMap[type]
      if (route) {
        // 构建完整URL
        let targetUrl = route.url
        if (route.query) {
          const queryString = Object.keys(route.query)
            .map(key => `${encodeURIComponent(key)}=${encodeURIComponent(route.query[key])}`)
            .join('&')
          // 判断URL中是否已有参数
          const separator = targetUrl.includes('?') ? '&' : '?'
          targetUrl = `${targetUrl}${separator}${queryString}`
        }
        // 使用 window.open 在新标签页打开，或者使用 window.location.href 在当前页面跳转
        if(type === 'apk'){
          window.open(targetUrl, '_blank')
        }else {
          Cookies.set('clientInfo', this.clientInfo)
          Cookies.set('channel', this.channel)
          Cookies.set('deviceName', this.deviceName)
          this.$router.push({
            path: targetUrl,
            query: route.query,
          })
        }

      } else {
        console.warn(`未知的跳转类型: ${type}`)
      }
    }
  },
}
</script>

<style lang="scss">
@import "../../public/static/css/app";

.scanredirect-page {
  .content {
    height: 100%;

    .topPic {
      height: 130px;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;
      background: #006EFF;
      color: #fff;

      .van-image {
        border-radius: 50%;
        overflow: hidden;
      }
    }

    .dataWrap {
      background: #006EFF;
      color: #fff;
      height: 4rem;
      border-top: 1px solid #fff;

      .nut-col {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        height: 100%;
        overflow: hidden;

        &:first-child {
          border-right: 1px solid #fff;
        }

        span {
          width: 100%;
          word-wrap: break-word;
          text-align: center;
          max-height: 40px;
          overflow: hidden;
        }
      }
    }

    .item-row {
      margin: 10px 0;
      background: #fff;

      .cell-right {
        float: right;
      }

      .van-icon {
        font-size: 18px;
        margin-right: 4px;
        img{
          width: 30px;
          height: 30px;
          margin-right: 10px;
        }
      }

      .van-empty{
        display: flex;
        align-items: flex-end;
        justify-content: center;
      }
      .text-content {
        flex: 1;
        display: flex;
        flex-direction: column;
      }

      .text-title {
        font-weight: 600; /* 加粗 */
        color: #323233;
        font-size: 16px;
        line-height: 1.5;
        margin-bottom: 2px;
      }

      .text-subtitle {
        font-weight: 400; /* 正常粗细 */
        color: #646566;
        font-size: 13px; /* 比标题小 */
        line-height: 1.4;
        opacity: 0.8; /* 稍微透明 */
      }
    }
    .van-cell{
      padding: 20px ;
    }
    .van-cell__title {
      & > div {
        display: flex;
        align-items: center;
        justify-content: space-between;
      }

    }

  }
  .addr{
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    max-width: 180px;
  }
  .bigBtn {
    padding: 0 20px;

    .van-button--large {
      border-radius: 40px;
    }
  }
  .contact{
    .van-field__body{
      border-bottom: #131212 1px solid;
    }
    .van-field__label{
      width: 100%;
    }
    .van-cell{
      display: flex;
      flex-direction: column;
    }
  }
  .select-groupings{
    .van-cell{
      padding: 20px;
    }
    .language{
      height: 300px;
      overflow-y: auto;
    }
  }
  [class*=van-hairline]::after{
    border: none;
  }
}
</style>
